import React, { useEffect } from "react";
import { UiTextIconButton } from "../../_uiComponents/common/UiButton";
import { UiPayAgainCard } from "../../_uiComponents/common/UiPayAgainCard";
import DialogLogo from "../../../styles/img/dialog-logo.png";
import Alogo from "../../../styles/img/A-logo.png";
import emptyscreenFavourite from "../../../styles/img/empty-screen-favourite.png";

import { BookmarkIcon } from "../../../styles/img/svg/BookmarkIcon";
import { Grid } from "@mui/material";
import { UiWhiteCard } from "../../_uiComponents/common/UiWhiteCard";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getRecentFavouritesListRequest,
  setFavouriteScreenType,
  setSelectedFavourite,
  setSelectedNavigationPathName,
} from "../../../_redux/_actions/favourites.actions";
import { UiGrayBgLoader } from "../../_uiComponents/common/UiGrayBgLoader";
import { commonConstants, TRANSLATION_CONST } from "../../../_redux/_constants";
import { useNavigate } from "react-router-dom";
import { UiDashboardEmptyMessage } from "../../_uiComponents/ErrorMessages/UiEmptyScreens";

export const FavoritesList = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const actionDispatch = useDispatch();

  const favourites = useSelector((state) => state.favourites);
  const { lang } = useSelector((state) => ({
    lang: state.lang,
  }));

  const { recentFavouriteList, isRecentFavouritesLoading } = favourites;

  useEffect(() => {
    if (!lang?.defaultLang) return;

    let recentFavouritesListPayload = {
      locale: lang.defaultLang,
    };

    actionDispatch(getRecentFavouritesListRequest(recentFavouritesListPayload));
  }, [lang?.defaultLang]);

  const toBillPay = (data) => {
    actionDispatch(setSelectedFavourite(data));
    actionDispatch(
      setFavouriteScreenType(commonConstants.FAVOURITE_FORM_TYPE_SCREEN),
    );
    actionDispatch(setSelectedNavigationPathName(window.location.pathname));
    navigate("/app/favourites");
  };

  const handleAllFavourites = () => {
    navigate("/app/favourites");
  };

  return (
    <UiWhiteCard className="df-play-again">
      <Grid container className="mb-2">
        <Grid size={7}>
          <h2 className="df-play-again__title">{t("Pay Again")}</h2>
        </Grid>
        <Grid size={5} className="text-right">
          <UiTextIconButton
            icon={<BookmarkIcon />}
            onClick={() => handleAllFavourites()}
            name={t("All Favourites")}
            className={
              i18n.language === TRANSLATION_CONST?.TAMIL.lan
                ? "df-primary-underlined-text-icon-btn df-primary-underlined-text-icon-btn-tamil"
                : "df-primary-underlined-text-icon-btn"
            }
          />
        </Grid>
      </Grid>

      {isRecentFavouritesLoading ? (
        <UiGrayBgLoader className="df-ch-330" />
      ) : Array.isArray(recentFavouriteList) &&
        recentFavouriteList.length > 0 ? (
        <div className="df-play-again__grid">
          {recentFavouriteList.map((data) => (
            <UiPayAgainCard
              key={data?.id ?? `${data?.nickname}-${data?.accountNumber}`}
              logo={
                (data?.bankUrl || data?.payeeTypeLogo) &&
                process.env.NFS_PUBLIC_IMAGE_URL +
                  (data?.transactionTypeName ===
                  commonConstants.FAVOURITE_TYPE_FUND_TRANSFTER
                    ? data?.bankUrl
                    : data?.payeeTypeLogo)
              }
              title={data.nickname}
              description={
                data?.transactionTypeName ===
                commonConstants.FAVOURITE_TYPE_FUND_TRANSFTER
                  ? `A/C: ${data.accountNumber}`
                  : data.accountNumber
              }
              handleOnclick={() => toBillPay(data)}
            />
          ))}
        </div>
      ) : (
        <UiDashboardEmptyMessage
          icon={emptyscreenFavourite}
          className="df-fs-fav df-pw-66"
          message={t("Your recent favourites will show up here.")}
        ></UiDashboardEmptyMessage>
      )}
    </UiWhiteCard>
  );
};
